// Pobierz wszystkie elementy <ul> na stronie
const ulElements = document.querySelectorAll('ul');

// Sprawdź, czy istnieją elementy <ul> z list-style-type: square
const hasSquareListStyle = Array.from(ulElements).some(ul => {
    const computedStyle = window.getComputedStyle(ul);
    return computedStyle.getPropertyValue('list-style-type') === 'square';
});

// Jeśli istnieją, dodaj klasę 'unavailable' do odpowiednich elementów <ul>
if (hasSquareListStyle) {
    ulElements.forEach(ul => {
        const computedStyle = window.getComputedStyle(ul);
        if (computedStyle.getPropertyValue('list-style-type') === 'square') {
            ul.classList.add('unavailable');
        }
    });
}
